import { useEffect } from 'react';
import { Button } from 'antd';
import { CalendarOutlined, RobotOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import PageHeader from 'components/headings/PageHeader';
import CalendarWidget from 'components/calendar/CalendarWidget';
import CalendarSidePanel from 'components/calendar/CalendarSidePanel';
import { useMantenciones } from 'providers/MantencionesProvider';
import paths from 'assets/routes/paths';

const MantencionesCalendario = () => {
  const { hasCalled: mantencionesHasCalled, call: callMantenciones } = useMantenciones();

  useEffect(() => {
    if (!mantencionesHasCalled) {
      callMantenciones();
    }
  }, [callMantenciones, mantencionesHasCalled]);

  return (
    <div className="p-4">
      <PageHeader
        icon={CalendarOutlined}
        title="Calendario de Mantenciones"
        subtitle="Asigna solicitudes al día seleccionado desde el panel lateral"
        actions={
          <Link to={paths.admin.mantenciones.actividades}>
            <Button icon={<RobotOutlined />} type="link" size="small">
              Actividades
            </Button>
          </Link>
        }
      />

      <div
        className="grid grid-cols-1 gap-4"
        style={{ gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 400px)' }}
      >
        <div className="min-w-0">
          <CalendarWidget />
        </div>
        <CalendarSidePanel />
      </div>
    </div>
  );
};

export default MantencionesCalendario;
